import React, {Fragment} from "react";
import { connect } from "react-redux";
import invert from "lodash/invert";

import {loaderEnable} from "../ui/loaderView";
import {
  toggleUserPopup, setCanvasId, setLayoutDataParts, setDefaultSelectionGroup, loadFilters, setCameFromPage,
  toggleBathroomVisualizerOpen, toggleSelectionFeatureInfo, changeMessageBoxState,
  addVisualizersLoaded, addToCart, setFirstLoadedPreset, updateCanvasCount
} from "../../actions/actionFunctions";
import {getBathroomVisualizerData, getBvGroups} from "../../api/server-api";
import {Layout} from "./core/layout";

import Visualizer from "../visComponents/visualizer";
import {IS_QKB_UI} from "../../config";
import {LayoutType, LOCAL_STORAGE_KEYS} from "./core/constants";
import {setLocalStorageItem} from "../../misc/storageFunctions";
import {setLookOverlayOpened} from "../../actions/lookFunctions";
import {getPassedUserInfo, getSaveTempData} from "../../api/look-api";
import Misc from "../../misc/misc";
import ImageCanvasCommonNew from "../visComponents/imageCanvasCommonNew";
import Copyright from "../ui/copyright";
import MainButtons from "../common/mainButtons";
import MobileNavigation from "./navigation/mobileNavigation";
import DesktopNavigation from "./navigation/desktopNavigation.js";
import MessageBox from "../popups/messageBox";
import VisualizerTutorial from "../tutorials/visualizerTutorial";
import {loadAdditionalVisualizerGroups} from "../../misc/loadVisualizer";
import {showVisualizerTutorial} from "../../actions/tutorialFunctions";

export const layout = new Layout();

class LookVisualizer extends Visualizer {

  static displayName = 'BvLookVisualizer';

  constructor(props) {
    super(props);
    this.layout = layout;
  }

  componentDidMount() {
    if (this.props.visualizersLoaded.includes(this.layout.visualizerType)) {
      this.setSubscribers();
      return false
    }
    if (!IS_QKB_UI) {
      this.props.toggleBathroomVisualizerOpen(true);
    }
    loaderEnable();
    Promise.all([
      getBathroomVisualizerData(),
      this.getQtCategoriesCommon(),
    ]).then(baseResponse => {
      let otherData = [
        Promise.resolve(baseResponse[0]),
        loadAdditionalVisualizerGroups("bvLook"),
        Promise.resolve(baseResponse[1]),
        getBvGroups(),
      ];
      const searchParams = new URLSearchParams(
        (window.location.search).replace(/amp;/g, "")
        || (window.location.hash).replace(/(.*)\?/g, "")
        || ""
      );
      // console.log("searchParams", searchParams.toString());
      if (searchParams && searchParams.get("userid")) {
        otherData.push(getPassedUserInfo(searchParams))
      }
      if (searchParams && (searchParams.get("tempID") || searchParams.get("TempID"))) {
        otherData.push(getSaveTempData(searchParams.get("tempID") || searchParams.get("TempID")))
      }
      Promise.all(otherData)
        .then((allResponse) => {
          console.log("allResponse", allResponse);
          const mainResponse = allResponse[0];
          const decorAndAttachmentResponses = Array.isArray(allResponse[1]) ? allResponse[1] : [];
          const qtCategories = allResponse[2];
          const bvGroupsResponse = allResponse[3];
          const userDataResponse = allResponse[4];
          const savedTempData = JSON.parse(searchParams && searchParams.get("userid") ? allResponse[5] || null : allResponse[4] || null);
          this.layout.loadNewFeatures(Object.assign({}, mainResponse, {
            features: [...mainResponse.features, ...decorAndAttachmentResponses]
          })); // 1) set default (placeholders)
          // this.layout.setGroupsItemsCount(mainResponse);
          let userIsLoggedIn = false;
          if (userDataResponse && userDataResponse.email) {
            userIsLoggedIn = true;
            this.needToSaveQuote = !document.kvConfig.jobId;
            console.log("userDataResponse", userDataResponse);
            const updatedUserInfo = Misc.parseUserResponse(userDataResponse)
            setLocalStorageItem(LOCAL_STORAGE_KEYS.introVisited, true);

            this.props.toggleUserPopup({
              userPopupOpened: false,
              userIsLoggedIn: true,
              isPhoneNumberValidated: userDataResponse.isPhoneNumberValidated || !userDataResponse.pendingPhoneVerification,
              userInfo: updatedUserInfo,
              // email: userDataResponse.email,
              encodedUserId: userDataResponse.encodedUserId,
              // phoneNumber: userDataResponse.phoneNumber,
              // values: userDataResponse.values
            })
          }
          return this.setVisualizerInfo(
            mainResponse,
            bvGroupsResponse ? bvGroupsResponse.data : {},
            qtCategories,
            invert(LayoutType),
            userIsLoggedIn,
            savedTempData
          );
        })
        .then(this.checkShareUrl)
        .then(this.onBvLoad)
        .then(this.finishLoading);
    });

    this.setSubscribers();
  }

  render() {
    if (!IS_QKB_UI) {
      return null
    }

    const showPlaceHolders = document.bvConfig ? document.bvConfig.showPlaceholders : false;
    const fabricatorSettings = this.props.fabricatorSettings;
    const layers = this.layout.getLayers(showPlaceHolders);
    const layoutType = this.layout.getCurrentLayoutName();
    const layoutScene = this.layout.scene;
    const isMobile = this.props.windowWidth < 991;
    const showTutorial = this.checkToShowTutorial();

    return (
      <div className={"main main--bv_look"
        + (this.props.desktopNavigationOpened ? " main--nav-opened" : "")
        + (this.props.activeNavigationParentName ? " main--" + this.props.activeNavigationParentName : "")
        + (this.props.activeNavigationChildName ? " main--" + this.props.activeNavigationChildName : "")
      }>
        <div className="wrapper">
          {this.props.bvOpened || this.props.bvVisited ? (
            <Fragment>
              <ImageCanvasCommonNew layers={layers}
                                    canvasId={this.state.canvasId}
                                    ref={(node) => this.imageCanvas = node}
                                    layoutType={layoutType}
                                    layout={this.layout}
                                    layoutScene={layoutScene}
                                    width={this.props.canvasDimensions.width}
                                    height={this.props.canvasDimensions.height}
                                    useMouseHovering={this.props.useMouseHovering}
                                    useTouchZoom={this.props.useTouchZoom}
              />
              <Copyright/>
            </Fragment>
          ) : null}
          <MainButtons goToCart={this.goToCart}
                       changeMessageBoxState={this.changeMessageBoxState}
                       resetEverything={this.resetEverything}
                       canvasId={this.state.canvasId}
          />
        </div>
        {(this.layout.initialized && this.props.bvVisited) ? ( // keep navigation opened if someone got to QT and back
          isMobile ? (
            <MobileNavigation refreshCB={this.handleRefresh}
                              setHoveredLayer={this.setHoveredLayer}
                              canvasId={this.state.canvasId}
                              renderGreenLayerByZindex={this.renderGreenLayerByZindex}
                              setCanvasClass={this.setCanvasClass}
                              resetEverything={this.resetEverything}
                              userIsLoggedIn={this.props.userIsLoggedIn}
                              toggleUserPopup={this.props.toggleUserPopup}
                              changeMessageBoxState={this.changeMessageBoxState}
                              setActiveFeature={this.setActiveFeature}
                              activeFeature={this.state.activeFeature}
                              fabricatorSettings={fabricatorSettings}
                              isPhoneNumberValidated={this.props.isPhoneNumberValidated}
                              setDemoPointClicked={this.setDemoPointClicked}
            />
          ) : (
            <DesktopNavigation ref={(node) => this.navBar = node}
                               refreshCB={this.handleRefresh}
                               setHoveredLayer={this.setHoveredLayer}
                               canvasId={this.state.canvasId}
                               renderGreenLayerByZindex={this.renderGreenLayerByZindex}
                               toggleUserPopup={this.props.toggleUserPopup}
                               changeMessageBoxState={this.changeMessageBoxState}
                               setActiveFeature={this.setActiveFeature}
                               activeFeature={this.state.activeFeature}
                               fabricatorSettings={fabricatorSettings}
                               setDemoPointClicked={this.setDemoPointClicked}
            />
          )
        ) : null}
        {this.props.cookieAccepted ? <MessageBox state={this.state.messageBoxState}/> : null}
        {showTutorial ? <VisualizerTutorial isMobile={isMobile}/> : null}
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  const {windowWidth, cookieAccepted, visualizersLoaded} = store.serverState;
  const {canvasId} = store.bathroomVisualizerState;
  const {isPhoneNumberValidated, userIsLoggedIn} = store.userState;
  const {activePreset} = store.bathroomVisualizerState;

  if (!IS_QKB_UI) {
    return {
      isPhoneNumberValidated,
      userIsLoggedIn,
      windowWidth,
      canvasId,
      activePreset,
      fabricatorSettings: store.fabricatorState.settings,
      qtActiveCategory: store.qtState.qtActiveCategory,
      visualizersLoaded,
    };
  }

  const {bvOpened, bvVisited, showRestorePopup, canvasDimensions, canvasCount} = store.bathroomVisualizerState;
  const {mobileNav, desktopNavigationOpened, activeNavigationParentName, activeNavigationChildName} = store.navigationState;
  const {visualizerTutorialIsOpened, visualizerTutorialFinished} = store.tutorialState;
  const {initialFlowRoomLayout, initialFlowRoom, initialFlowStep} = store.initialFlowState;
  const {qtCategoriesRequested} = store.qtState;

  return {
    isPhoneNumberValidated,
    userIsLoggedIn,
    windowWidth,
    canvasId,
    activePreset,
    fabricatorSettings: store.fabricatorState.settings,
    qtActiveCategory: store.qtState.qtActiveCategory,
    //** qkb ui ** //
    bvOpened,
    bvVisited,
    mobileNav,
    desktopNavigationOpened,
    activeNavigationParentName,
    activeNavigationChildName,
    showRestorePopup,
    visualizerTutorialIsOpened,
    visualizerTutorialFinished,
    initialFlowRoomLayout,
    initialFlowRoom,
    initialFlowStep,
    cookieAccepted,
    canvasDimensions,
    visualizersLoaded,
    qtCategoriesRequested,
    canvasCount,
  };
};

const mapDispatchToProps = {
  setCameFromPage,
  toggleBathroomVisualizerOpen,
  setDefaultSelectionGroup,
  setLayoutDataParts,
  toggleUserPopup,
  setCanvasId,
  loadFilters,
  toggleSelectionFeatureInfo,
  changeMessageBoxState,
  addVisualizersLoaded,
  addToCart,
  setLookOverlayOpened,
  setFirstLoadedPreset,
  updateCanvasCount,
  showVisualizerTutorial,
};

export default connect(mapStateToProps, mapDispatchToProps)(LookVisualizer)
